module.exports = __webpack_public_path__ + "6b02afba718661dfdf731ddb367ef6e0.png";